import { Petal } from "src/components/charts/flower/Flower";
import { Box, keyframes } from "@mui/material";
import * as StemComponent from "src/components/charts/flower/Stem";

export interface StemProps {
    index: number;
    color: Petal["color"];
    numberOfPetals: number;
    flowDirection?: "fromPetal" | "toPetal";
}

export const NUMBER_OF_ARROWS = 3;

type ArrowProps = Required<Pick<StemProps, "flowDirection">> & {
    index: number;
};

export const createArrowKeyframes = (fromY: number, toY: number) => {
    return keyframes`
      from {
        opacity: 1;
        transform: translateY(${fromY}px);
      }
      to {
        opacity: 1;
        transform: translateY(${toY}px);
      }
    `;
};

const Arrow = ({ index, flowDirection }: ArrowProps) => {
    const isMovingToPetal = flowDirection === "toPetal";
    const signOfAngleBefore = isMovingToPetal ? "+" : "-";
    const signOfAngleAfter = isMovingToPetal ? "-" : "+";
    const [fromY, toY] = isMovingToPetal ? [-10, 60] : [60, -10];
    return (
        <Box
            data-testid="stem-arrow"
            sx={{
                position: "absolute",
                width: "16px",
                height: "2px",
                opacity: 0,
                animation: `${StemComponent.createArrowKeyframes(fromY, toY)} 6s linear infinite`,
                animationDelay: `${index * 2}s`,
                "& .arrow-part": {
                    position: "absolute",
                    top: 0,
                    height: "100%",
                    width: "50%",
                    background: "rgba(255, 255, 255, 0.5)",
                },
                "& .arrow-part.left": {
                    left: 0,
                    transform: `skewY(${signOfAngleBefore}45deg)`,
                },
                "& .arrow-part.right": {
                    right: 0,
                    transform: `skewY(${signOfAngleAfter}45deg)`,
                },
            }}
        >
            <div className="arrow-part left" />
            <div className="arrow-part right" />
        </Box>
    );
};
export const Stem = ({ index, color, flowDirection, numberOfPetals }: StemProps) => {
    const anglePerPetal = 360 / numberOfPetals;
    const arrows = Array.from({ length: NUMBER_OF_ARROWS }, (_, index) => index + 1);
    return (
        <Box
            key={`stem-${index}`}
            data-testid="stem"
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                height: "55px",
                width: "16px",
                background: color,
                opacity: "0.5",
                transform: `translate(-50%, -50%) rotate(${180 + anglePerPetal + index * anglePerPetal}deg) translate(0px, 40px)`,
            }}
        >
            {flowDirection &&
                arrows.map((_item, index) => <Arrow key={`stem-arrow-${index}`} index={index} flowDirection={flowDirection} />)}
        </Box>
    );
};
